export default __webpack_public_path__ + "static/thumb-13-4e66b82809beb3fd6306a934a382de2e.jpg";